import { type SendScreenEventInput } from './types';

export function buildLocationFields(event: SendScreenEventInput): any {
	const payload = typeof event === 'object' ? event : undefined;

	return {
		title: '',
		path: typeof payload?.path === 'string' ? payload.path : '',
		url: typeof payload?.url === 'string' ? payload.url : '',
		referrer: '',
		search: '',
	};
}
